import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FaChevronCircleDown  } from "react-icons/fa";
import { FaShare, FaShareSquare } from "react-icons/fa";
import { IoShareOutline } from "react-icons/io5";
import { IconName } from "react-icons/bi";


import httpCommon from "../../http-common";
import axios from "axios";
import Slider from "../../component/slider/slider";
import Container from "../../component/Container";
import InquiryForm from './InquiryForm';
import DialogProperty from "../../component/card/DialogProperty";
import Social from "../../component/Social";
import PropertyDetails from "../../component/propertyDetail/PropertyDetail";
import MortgageCalculator from "./MortgageCalculator";
import MultiCrousel from "../../component/MultiCrousel";

function SinglePage() {
  const [loading, setLoading] = useState(true);
  const { propertyurl } = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [properties, setProperties] = useState([]);
  const [singlePageData, setSinglePageData] = useState([]);
  const [similarProperties, setSimilarProperties] = useState([]);
  const [singlePageImgData, setSinglePageImgData] = useState([]);
  const [brochureData, setBrochureData] = useState([]);

  useEffect(() => {
    if (!propertyurl) {
      navigate("/Property");
      return;
    }
    fetchData();
  }, [propertyurl, navigate]);

  // useEffect(() => {
  //   if (properties.length && singlePageData.length) {
  //     const matchedType = singlePageData[0]?.ltg_type;
  //     const matchedCategory = singlePageData[0]?.ltg_categories;

  //     const similar = properties.filter(property =>
  //       property.ltg_type === matchedType &&
  //       property.ltg_categories === matchedCategory
  //     );
  //   //  setSimilarProperties(similar);
  //   }
  // }, [properties, singlePageData]);

  const handleClose = () => {
    setOpen(false);
  };

  // Fetch properties data
  // const fetchData = async () => {
  //   setLoading(true);
  //   try {
  //     const [allPropertiesResponse, singlePageResponse] = await Promise.all([
  //       httpCommon.get("/list"),
  //       httpCommon.get(`/list/singleProperty/${propertyurl}`)
  //     ]);

  //     if (allPropertiesResponse.data.status === "success") {
  //       console.log("test___",allPropertiesResponse.data.data);
  //       setProperties(allPropertiesResponse.data.data);
  //     }

  //     if (singlePageResponse.data.status === "success") {
  //       console.log("test___22",singlePageResponse.data.data);
  //       setSinglePageData(singlePageResponse.data.data);
  //     }

  //     try {
  //       const imgResponse = await httpCommon.get(`/list/singlePageImg/${propertyurl}`);
  //       if (imgResponse.data.status === "success") {
  //         const filteredData = imgResponse.data.data?.filter(item => item.type !== "Brochure");
  //         setSinglePageImgData(filteredData);

  //         const brochureData = imgResponse.data.data?.filter(item => item.type === "Brochure");
  //         setBrochureData(brochureData);
  //       }
  //     } catch (imgError) {
  //       console.warn("Failed to fetch single page image data:", imgError.message);
  //       setSinglePageImgData([]);
  //       setBrochureData([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error.message);
  //   }finally {
  //   setLoading(false); // ✅ Set loading to false once everything is fetched
  // }
  // };

const fetchData = async () => {
  setLoading(true);

  try {
    const res = await httpCommon.get(`/list/single-full/${propertyurl}`);
   // console.log("res___api___",res)
    // 🔥 FIXED MAPPING
    setSinglePageData(res.data.singleProperty);  
    setSinglePageImgData(res.data.images);
    setSimilarProperties(res.data.similarProperties);

  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

const type = singlePageData.ltg_type;
  const details = singlePageData.details || {};

  function formatPrice(price, onlyFormatted = false) {
    if (price == null) {
      return onlyFormatted ? "N/A" : { numeric: 0, formatted: "N/A" };
    }

    const numericPrice = parseFloat(price.replace(/,/g, ""));
    if (isNaN(numericPrice)) {
      return onlyFormatted ? "N/A" : { numeric: 0, formatted: "N/A" };
    }

    let formatted;
    if (numericPrice < 1000) {
      formatted = numericPrice.toString();
    } else if (numericPrice < 100000) {
      formatted = `${(numericPrice / 1000).toFixed(0)} Thousand`;
    } else if (numericPrice < 10000000) {
      // formatted = `${(numericPrice / 100000).toFixed(1)} Lakhs`;
      const lakhs = numericPrice / 100000;
      formatted = lakhs % 1 === 0 ? `${lakhs.toFixed(0)} Lakhs` : `${lakhs.toFixed(1)} Lakhs`;
    } else {
      // formatted = `${(numericPrice / 10000000).toFixed(2)} Cr`;
      const crores = numericPrice / 10000000;
      formatted = crores % 1 === 0 ? `${crores.toFixed(0)} Cr` : `${crores.toFixed(2)} Cr`;
    }

    return onlyFormatted ? formatted : { numeric: numericPrice, formatted };
  }

  const scrollToCalculator = () => {
    const element = document.getElementById('mortgage-calculator');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const addressMap  = {
     Plots: details.ltg_det_plot_address,
    Villas: details.ltg_det_address,
    Apartments: details.ltg_det_address,
    RowHouses: details.ltg_det_row_house_address,
    Villaments: details.ltg_det_villaments_address,
    PentHouses: details.ltg_det_penthouses_address,
    CommercialProperties: details.ltg_det_comm_prop_address,
  };

  const address = addressMap[type] || "Address not available";

  const priceMap = {
    Plots: details.ltg_det_plot_sale_price,
    Villas: details.ltg_det_sale_price,
    Apartments: details.ltg_det_sale_price,
    RowHouses: details.ltg_det_row_house_sale_price,
    Villaments: details.ltg_det_villaments_sale_price,
    PentHouses: details.ltg_det_penthouses_sale_price,
    CommercialProperties: details.ltg_det_comm_prop_sale_price,
  };

  const suffixPriceMap = {
    Plots: details.ltg_det_plot_suffix_price,
    Villas: details.ltg_det_suffix_price,
    Apartments: details.ltg_det_suffix_price,
    RowHouses: details.ltg_det_row_house_suffix_price,
    Villaments: details.ltg_det_villaments_suffix_price,
    PentHouses: details.ltg_det_penthouses_suffix_price,
    CommercialProperties: details.ltg_det_comm_prop_suffix_price,
  };

  const callForPriceMap = {
    Plots: details.ltg_det_plot_call_for_price,
    Villas: details.ltg_det_call_for_price,
    Apartments: details.ltg_det_call_for_price,
    RowHouses: details.ltg_det_row_house_call_for_price,
    Villaments: details.ltg_det_villaments_call_for_price,
    PentHouses: details.ltg_det_penthouses_call_for_price,
    CommercialProperties: details.ltg_det_comm_prop_call_for_price,
  };

  const price = priceMap[type];
  const suffixPrice = suffixPriceMap[type];
  const callForPrice = callForPriceMap[type];

  const { numeric: numericPrice, formatted: formattedPrice } = formatPrice(
    price ? price.toLocaleString("en-IN") : "0"
  );

  const { numeric: numericSuffixPrice, formatted: formattedSuffixPrice } =
    formatPrice(suffixPrice ? suffixPrice.toLocaleString("en-IN") : "0");

  const getPropertyDetails = (type, item) => {
    switch (type) {
      case 'CommercialProperties':
        return {
          description: item.ltg_det_comm_prop_desc,
          price: formatPrice(item.ltg_det_comm_prop_sale_price, true),
          suffixPrice: formatPrice(item.ltg_det_comm_prop_suffix_price, true),
          callForPrice: item?.ltg_det_comm_prop_call_for_price,
          bedroom: '', // empty for CommercialProperties
          bathroom: '', // empty for CommercialProperties
          parking: item.ltg_det_comm_prop_pmts_car_parking,
          area: item.ltg_det_comm_prop_pmts_area_dts,
          address: item.ltg_det_comm_prop_address,
          RowID: item.ltg_det_mstRowID,
          type: item.ltg_type,
          featured: item.ltg_mark_as_featured,
        };
      case 'PentHouses':
        return {
          description: item.ltg_det_penthouses_desc,
          price: formatPrice(item.ltg_det_penthouses_sale_price, true),
          suffixPrice: formatPrice(item.ltg_det_penthouses_suffix_price, true),
          callForPrice: item?.ltg_det_penthouses_call_for_price,
          bedroom: item.ltg_det_penthouses_pmts_bed_rooms,
          bathroom: item.ltg_det_penthouses_pmts_bath_rooms,
          parking: item.ltg_det_penthouses_pmts_car_parking,
          area: item.ltg_det_penthouses_pmts_area_dts,
          address: item.ltg_det_penthouses_address,
          RowID: item.ltg_det_mstRowID,
          type: item.ltg_type,
          featured: item.ltg_mark_as_featured,
        };
      case 'Plots':
        return {
          description: item.ltg_det_plot_desc,
          price: formatPrice(item.ltg_det_plot_sale_price, true),
          suffixPrice: formatPrice(item.ltg_det_plot_suffix_price, true),
          callForPrice: item?.ltg_det_plot_call_for_price,
          bedroom: '', // empty for Plots
          bathroom: '', // empty for Plots
          parking: '', // empty for Plots
          area: item.ltg_det_plot_pmts_area_dts,
          address: item.ltg_det_plot_address,
          RowID: item.ltg_det_mstRowID,
          type: item.ltg_type,
          featured: item.ltg_mark_as_featured,
        };
      case 'RowHouses':
        return {
          description: item.ltg_det_row_house_desc,
          price: formatPrice(item.ltg_det_row_house_sale_price, true),
          suffixPrice: formatPrice(item.ltg_det_row_house_suffix_price, true),
          callForPrice: item?.ltg_det_row_house_call_for_price,
          bedroom: item.ltg_det_row_house_pmts_bed_rooms,
          bathroom: item.ltg_det_row_house_pmts_bath_rooms,
          parking: item.ltg_det_row_house_pmts_car_parking,
          area: item.ltg_det_row_house_pmts_area_dts,
          address: item.ltg_det_row_house_address,
          RowID: item.ltg_det_mstRowID,
          type: item.ltg_type,
          featured: item.ltg_mark_as_featured,
        };
      case 'Villaments':
        return {
          description: item.ltg_det_villaments_desc,
          price: formatPrice(item.ltg_det_villaments_sale_price, true),
          suffixPrice: formatPrice(item.ltg_det_villaments_suffix_price, true),
          callForPrice: item?.ltg_det_villaments_call_for_price,
          bedroom: item.ltg_det_villaments_pmts_bed_rooms,
          bathroom: item.ltg_det_villaments_pmts_bath_rooms,
          parking: item.ltg_det_villaments_pmts_car_parking,
          area: item.ltg_det_villaments_pmts_area_dts,
          address: item.ltg_det_villaments_address,
          RowID: item.ltg_det_mstRowID,
          type: item.ltg_type,
          featured: item.ltg_mark_as_featured,
        };
      default:
        return {
          description: item.ltg_det_desc,
          price: formatPrice(item.ltg_det_sale_price, true),
          suffixPrice: formatPrice(item.ltg_det_suffix_price, true),
          callForPrice: item?.ltg_det_call_for_price,
          bedroom: item.ltg_det_pmts_bed_rom,
          bathroom: item.ltg_det_pmts_bth_rom,
          parking: item.ltg_det_pmts_car_park,
          area: item.ltg_det_pmts_area_dts,
          address: item.ltg_det_address,
          RowID: item.ltg_det_mstRowID,
          type: item.ltg_type,
          featured: item.ltg_mark_as_featured,
        };
    }
  };

const SimilarP = similarProperties.map(item => {

  const mainImage = item.attachments?.find(a => a.type === "Main");

  const imgUrl = mainImage
    ? httpCommon.defaults.baseURL + mainImage.attachment
    : httpCommon.defaults.baseURL + "/images/defaultasset.jpg";

  return {
    key: item.RowID,
    title: item.ltg_title,
    imgUrl,
    address: item.ltg_det_address || item.ltg_det_plot_address,
    price: item.ltg_det_sale_price || item.ltg_det_plot_sale_price,
    suffixPrice: item.ltg_det_suffix_price,
    callForPrice: item.ltg_det_call_for_price,
    bathroom: item.ltg_det_pmts_bth_rom,
    area: item.ltg_det_pmts_area_dts,
    parking: item.ltg_det_pmts_car_park,
    featured: item.ltg_mark_as_featured,
    details: item   // full merged data
  };
});



const singleRowID = singlePageData?.details?.ltg_det_mstRowID;
const singleType = singlePageData?.ltg_type;

  useEffect(() => {
    if (singlePageData?.[0]) {
      const projectName = singlePageData[0].ltg_projectName || "Property Name";
      const projectTitle = singlePageData[0].ltg_title || "Property Title";
      const imageUrl = singlePageData[0].ltg_imageUrl || "/images/WhatsApp%20Image%202025-01-02%20at%205.29.45%20PM.jpeg";

      // Update Open Graph meta tags
      document.querySelector("meta[property='og:title']")?.setAttribute("content", projectName);
      document.querySelector("meta[property='og:description']")?.setAttribute("content", projectTitle);
      document.querySelector("meta[property='og:image']")?.setAttribute("content", imageUrl);
      document.querySelector("meta[property='og:url']")?.setAttribute("content", window.location.href);
    }
  }, [singlePageData]);

  const handleShareClick = () => {
  if (!singlePageData) {
    console.error("No data available for sharing.");
    return;
  }

  const projectName =
    singlePageData.ltg_projectName || "Property Name";

  const projectTitle =
    singlePageData.ltg_title || "Property Title";

  const currentPageUrl = window.location.href;

  const imageUrl =
    singlePageData.ltg_imageUrl ||
    "/images/defaultasset.jpg";

  const message = encodeURIComponent(
    `${projectName}\n${projectTitle}\n\nCheck this property:\n${currentPageUrl}`
  );

  const whatsappUrl = `https://wa.me/?text=${message}`;

  window.open(whatsappUrl, "_blank");
};


  // const handleShareClick = async() => {
  //   console.log("click___");
  //   if (singlePageData?.[0]) {
  //     const projectName = singlePageData[0].ltg_projectName || "Property Name";
  //     const projectTitle = singlePageData[0].ltg_title || "Property Title";
  //     const currentPageUrl = window.location.href;
  //     const imageUrl = singlePageData[0].ltg_imageUrl || "/images/WhatsApp%20Image%202025-01-02%20at%205.29.45%20PM.jpeg";
  
  //     const message = encodeURIComponent(
  //       `${projectName}\n${projectTitle}\n\nCheck this property: ${currentPageUrl}`
  //     );
  
  //     const whatsappUrl = `https://wa.me/?text=${message}`;
  //     window.open(whatsappUrl, "_blank");
      
  //   } else {
  //     console.error("No data available for sharing.");
  //   }
  // };

  const mergedProperty = singlePageData
  ? { ...singlePageData, ...singlePageData.details }
  : null;

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-lg font-semibold text-gray-600">Loading property details...</p>
      </div>
    );
  }
  
  return (
    <>
    <Container className="py-10">
      
      <DialogProperty
        open={open}
        setOpen={setOpen}
        item={singlePageData}
        handleClose={handleClose}
      />
      
      {/* Slider Section */}
      <div className="mb-10">
        <Slider images={singlePageImgData} />
      </div>

      {/* Details Section */}
      

      <div className="p-4 md:p-6 mb-10 bg-white rounded-xl shadow-sm">
      <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">

        {/* LEFT CONTENT */}
        <div className="flex-1">
          <h1 className="text-sm uppercase tracking-wide text-gray-500">
            {singlePageData.ltg_projectName}
          </h1>

          <h2 className="mt-1 text-2xl md:text-3xl font-bold text-gray-900 leading-snug">
            {singlePageData.ltg_title}
          </h2>

          {/* Location */}
          <div className="flex items-start gap-2 mt-3 text-gray-600">
            <img src="/pin.png" alt="Location" className="w-5 h-5 mt-0.5" />
            <p className="text-sm md:text-base leading-relaxed">
              {address}
            </p>
          </div>
        </div>

        {/* RIGHT PRICE CARD */}
        <div className="w-full md:w-[200px]">
          <div
            className={`
              relative p-4 rounded-xl shadow-lg text-white
              ${
                numericPrice > 0
                  ? "bg-gradient-to-br from-blue-500 to-teal-500"
                  : "bg-gradient-to-r from-slate-600 to-slate-700"
              }
            `}
          >
            {/* Share */}
            <IoShareOutline
              className="absolute top-3 right-3 text-2xl cursor-pointer hover:opacity-80"
              title="Share"
              onClick={handleShareClick}
            />

            {/* Price / Call For Price */}
            {numericPrice > 0 ? (
            <div className="inline-block">
              <div className="text-2xl md:text-3xl font-bold">
                ₹{formattedPrice}
              </div>

              {numericSuffixPrice > 0 && (
                <div className="mt-1 text-sm line-through opacity-80">
                  ₹{formattedSuffixPrice}
                </div>
              )}
            </div>
          ) : (
            <div
              className="
                inline-block
                px-4 py-2
                text-xl md:text-2xl
                font-semibold italic tracking-wide
                bg-gradient-to-r from-slate-600 to-slate-700
                text-white
                rounded-lg
                shadow-md
                whitespace-nowrap
              "
            >
              {callForPrice || "Call for Price"}
            </div>
          )}

          </div>

          {/* Mortgage CTA */}
          <button
            onClick={scrollToCalculator}
            className="mt-3 flex items-center justify-center gap-2 w-full text-sm md:text-base font-medium text-blue-600 hover:underline"
          >
            Est. Mortgage Calculator <FaChevronCircleDown />
          </button>
        </div>

      </div>
    </div>


      {/* Property Details Section */}
      <PropertyDetails property={[mergedProperty]}  images={singlePageImgData} brochure={brochureData} />
      {console.log("SimilarP___",SimilarP)}
      {/* Similar Properties */}
      {SimilarP && SimilarP.length > 0 && (
        <section>
          <h2 className="mb-4 ml-2 text-2xl font-bold">Similar Properties</h2>
          <MultiCrousel data={SimilarP} details={true} />
        </section>
      )}

      {/* Mortgage Calculator Section */}
      <section id="mortgage-calculator" className="mt-10">
        <MortgageCalculator price={numericPrice} />
      </section>

      {/* InquiryForm Section */}
      <section className="mt-10">
        <InquiryForm propertyId={singleRowID} listingType={singleType} item={singlePageData} />
      </section>

      {/* Social Section */}
      <Social />
    </Container>
    </>
  );
}


export default SinglePage;
